import { GenericErrorMessage } from '@core/constants/sna-error-messages';

export function getGenericErrorMessage(): string {
  return `${GenericErrorMessage.title} ${GenericErrorMessage.message}`;
}
